export class ContractorsOfContractorFilesRequest {

    _page; // number
    _term; // string

    constructor() {
        this._page = 1;
        this._term = '';
    }

    setPage(page) {
        this._page = page;
    }

    setTerm(term) {
        this._term = term;
    }

    body() {
        return {
            criteria: {
                page: this._page,
                term: this._term,
            },
        };
    }

}



// WEBPACK FOOTER //
// ./src/app/documentary-library/list/webservices/list-contractors/ContractorsOfContractorFilesRequest.js